const vulnerabilityFieldsProfile = ['name', 'email'];

const vulnerabilityFieldsAddress = ['state', 'complement', 'address', 'neighborhood', 'addressnumber', 'city'];

export const defaultVulnerabilityFieldNames = [...vulnerabilityFieldsProfile, ...vulnerabilityFieldsAddress];
